import { Expose } from 'class-transformer';

export class HolidayDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;

  @Expose()
  startDate: Date;

  @Expose()
  endDate: Date;
}
